import React from 'react';
//import { Link } from 'react-scroll';

const PageTitleHome = () => {
    return (
        <section id="page-title" className="block with-img with-information-items" style={ { backgroundImage: `url('assets/img/home/home1.jpg')` } }>
            <div className="wrapper d-flex">
                <div className="align-self-center w-100">
                    <div className="title">
                        <h1 className="large">Let us help you get back on track!</h1>
                    </div>

                    {/*
                    <div className="description spacer p-top-lg text-max-width">
                        <p>We are an ACC Contracted Supplier and Southern Cross Easy-Claim Affliated Provider that aims to help people with all their Physiotherapy needs.</p>
                    </div>
                    */}

                    <div className="description spacer p-top-lg text-max-width bold">
                        <h2>Botany Physio is now based in the Howick Squash Club and Cockle Bay Tennis Club building.</h2>
                    </div>

                    {/*
                    <div className="spacer p-top-lg no-space">
                        <Link to="about-us" href="#about-us" className="btn btn-primary scroll-to-id btn-lg">Learn More</Link>
                    </div>
                    */}
                </div>
            </div>

            <div className="page-title-bg-color"></div>
        </section>
    );
};

export default PageTitleHome;
